module.exports = __webpack_public_path__ + "static/media/17.963bbb59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/17.svg
// module id = 2808
// module chunks = 3